import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) { return originalPush.call(this, location, onResolve, onReject) }
  return originalPush.call(this, location).catch(err => err)
}

// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) { return originalReplace.call(this, location, onResolve, onReject) }
  return originalReplace.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'home',
    // component: () => import('@/views/communityIntro/index.vue'),
    component: resolve => require(['@/views/communityIntro/index.vue'], resolve),
    redirect: '/communityIntro'
  }, {
    path: '/communityIntro',
    name: 'communityIntro',
    component: resolve => require(['@/views/communityIntro/index.vue'], resolve),
    meta: { title: '社区简介' }
  }, {
    path: '/publicityParty',
    name: 'publicityParty',
    component: resolve => require(['@/views/publicityParty/index.vue'], resolve),
    meta: { title: '党务公开' }
  }, {
    path: '/publicityHousing',
    name: 'publicityHousing',
    component: resolve => require(['@/views/publicityHousing/index.vue'], resolve),
    meta: { title: '居务公开' }
  },
  // {
  //   path: '/civilizationConstr',
  //   name: 'civilizationConstr',
  //   component: resolve => require(['@/views/civilizationConstr/index.vue'], resolve),
  //   meta: { title: '新时代文件实践' }
  // },
  {
    path: '/fireFighting',
    name: 'fireFighting',
    component: resolve => require(['@/views/fireFighting/index.vue'], resolve),
    meta: { title: '森林防灭火' }
  }, {
    path: '/veteransService',
    name: 'veteransService',
    component: resolve => require(['@/views/veteransService/index.vue'], resolve),
    meta: { title: '退役军人服务' }
  },
  // {
  //   path: '/epidemicControl',
  //   name: 'epidemicControl',
  //   component: resolve => require(['@/views/epidemicControl/index.vue'], resolve),
  //   meta: { title: '疫情防控' }
  // },
  // {
  //   path: '/ruralVitalization',
  //   name: 'ruralVitalization',
  //   component: resolve => require(['@/views/ruralVitalization/index.vue'], resolve),
  //   meta: { title: '乡村振兴' }
  // },
  {
    path: '/partyConduct',
    name: 'partyConduct',
    component: resolve => require(['@/views/partyConduct/index.vue'], resolve),
    meta: { title: '基层党风廉政' }
  }, {
    path: '/femaleFederation',
    name: 'femaleFederation',
    component: resolve => require(['@/views/femaleFederation/index.vue'], resolve),
    meta: { title: '妇联工作' }
  }, {
    path: '/newPage8',
    name: 'newPage8',
    component: resolve => require(['@/views/newPage8/index.vue'], resolve),
    meta: { title: '新建模板8' }
  }, {
    path: '/newPage9',
    name: 'newPage9',
    component: resolve => require(['@/views/newPage9/index.vue'], resolve),
    meta: { title: '新建模板9' }
  }, {
    path: '/newPage10',
    name: 'newPage10',
    component: resolve => require(['@/views/newPage10/index.vue'], resolve),
    meta: { title: '新建模板10' }
  }, {
    path: '/newPage11',
    name: 'newPage11',
    component: resolve => require(['@/views/newPage11/index.vue'], resolve),
    meta: { title: '新建模板11' }
  }, {
    path: '/newPage12',
    name: 'newPage12',
    component: resolve => require(['@/views/newPage12/index.vue'], resolve),
    meta: { title: '新建模板12' }
  },

  {
    path: '/hometownAtlas',
    name: 'hometownAtlas',
    component: resolve => require(['@/views/partyTop/hometownAtlas/index.vue'], resolve),
    meta: { title: '图说洪雅变化', isNotInFrame: true }
  }, {
    path: '/hometownAtlasDetail',
    name: 'hometownAtlasDetail',
    component: resolve => require(['@/views/partyTop/hometownAtlas/hometownAtlasDetail.vue'], resolve),
    meta: { title: '图说洪雅变化详情', isNotInFrame: true }
  }, {
    path: '/resultBook',
    name: 'resultBook',
    component: resolve => require(['@/views/partyTop/resultBook.vue'], resolve),
    meta: { title: '成果汇编', isNotInFrame: true }
  }, {
    path: '/peopleCongress20',
    name: 'peopleCongress20',
    component: resolve => require(['@/views/partyTop/peopleCongress20/index.vue'], resolve),
    meta: { title: '二十大', isNotInFrame: true }
  }, {
    path: '/partyBuilding',
    name: 'PartyBuilding',
    component: resolve => require(['@/views/partyTop/partyBuilding/index.vue'], resolve),
    meta: { title: '智慧党建', isNotInFrame: true }
  }, {
    path: '/partyBuildingDetail',
    name: 'PartyBuildingDetail',
    component: resolve => require(['@/views/partyTop/partyBuilding/detail.vue'], resolve),
    meta: { title: '智慧党建详情', isNotInFrame: true }
  }, {
    path: '/mobileIndex',
    name: 'MobileIndex',
    component: resolve => require(['@/views/partyTop/mobileIndex/index.vue'], resolve),
    meta: { title: '洪雅智慧党建云平台', isNotInFrame: true }
  },
  // {
  //   path: '/partyLiving',
  //   name: 'PartyLiving',
  //   component: resolve => require(['@/views/partyTop/peopleCongress20/partyLiving.vue'], resolve),
  //   meta: { title: '直播', isNotInFrame: true }
  // },
  {
    path: '/partyLivingM3U8',
    name: 'partyLivingM3U8',
    component: resolve => require(['@/views/partyTop/peopleCongress20/partyLivingM3U8.vue'], resolve),
    meta: { title: '直播', isNotInFrame: true }
  },

  {
    path: '/development',
    name: 'development',
    component: resolve => require(['@/views/development.vue'], resolve),
    meta: { title: '开发中' }
  },

  {
    path: '/filePrev',
    name: 'filePrev',
    component: resolve => require(['@/views/filePrev.vue'], resolve),
    meta: { title: 'filePrev', isNotInFrame: true }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
